export default __webpack_public_path__ + "static/media/plus-bold.919a0d1f.svg";